/// <reference types="vite/client" />

import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';
import './styles/pages.css';
import { AppController } from './app/controller';
import { offlineRegistration } from './app/offline-support';
import { AppRepository } from './storage/repository';

const root = document.querySelector<HTMLElement>('#app');

if (!root) {
  throw new Error('Missing #app root element');
}

new AppController(root, new AppRepository()).start();
void registerOfflineSupport();

async function registerOfflineSupport(): Promise<void> {
  if (!('serviceWorker' in navigator)) return;
  try {
    const options = offlineRegistration(window.location.pathname);
    const registration = await navigator.serviceWorker.register(options.scriptUrl, { scope: options.scope });
    monitorWorkerUpdates(registration);
  } catch {
    showOfflineUpdateError();
  }
}

function monitorWorkerUpdates(registration: ServiceWorkerRegistration): void {
  const monitorInstalling = (): void => {
    const worker = registration.installing;
    if (!worker) return;
    worker.addEventListener('error', showOfflineUpdateError, { once: true });
    worker.addEventListener('statechange', () => {
      if (worker.state === 'redundant') showOfflineUpdateError();
    });
    if (worker.state === 'redundant') showOfflineUpdateError();
  };
  registration.addEventListener('updatefound', monitorInstalling);
  if (registration.installing) monitorInstalling();
}

function showOfflineUpdateError(): void {
  if (document.querySelector('#offline-update-status')) return;
  const status = document.createElement('p');
  status.id = 'offline-update-status';
  status.className = 'offline-update-status';
  status.setAttribute('role', 'status');
  status.textContent = '暂时无法更新离线版本，联网后会重试';
  document.body.append(status);
}
